import $ from 'jquery';
import Swiper from 'swiper';
import Component from '../model/Component';

class CenteredSliderComponent extends Component {
    constructor(element, parentCtrl) {
        super(element, parentCtrl);

        this.$element = $(element);

        this.initSwiper();
    }

    initSwiper() {
        this.swiper = new Swiper(this.$element.find('.swiper-container'), {
            pagination: this.$element.find('.swiper-pagination'),
            nextButton: this.$element.find('.swiper-button-next'),
            prevButton: this.$element.find('.swiper-button-prev'),
            slidesPerView: 3,
            spaceBetween: 50,
            paginationClickable: true,
            loop: true,
            centeredSlides: true,
            keyboardControl: true,
            mousewheelControl: true,
            mousewheelForceToAxis: true,

            breakpoints: {
                767: {
                    slidesPerView: 1.2,
                }
            }
        });
    }
}

export default CenteredSliderComponent;
